import { Button } from '@components/Button';
import { Content, ErrorWrapper, Title } from './styled';

interface ErrorFallbackProps {
  error: any;
  recovery?: () => {};
}

function ErrorFallback({ error, recovery }: ErrorFallbackProps) {
  return (
    <ErrorWrapper>
      <Content>
        <Title>Something went wrong!</Title>
        <pre>
          {console.log(error)}
          {error?.message ||
            error?.description ||
            'An unknown error has occurred.'}
        </pre>
        <Button onClick={recovery}>Back to login</Button>
      </Content>
    </ErrorWrapper>
  );
}

export { ErrorFallback };
